<template>
  <div class="future-page">
    <BannerAtom
      :title="bannerTitle"
      :image="image"
      :currentPath="currentPath"
    />

    <div class="future-page__content" v-if="!isEnglish">
      <div class="future-page__textContent">
        <p class="future-page__content__paragraph">
          Det är en komplex fråga hur utsläpp av växthusgaser från byggandet ska
          minska kraftigt. Vi behöver göra flera saker samtidigt.
        </p>
        <ul class="future-page__content__ul">
          <li>Bygga mindre, bara det vi verkligen behöver.</li>
          <li>
            Använda både nya och befintliga byggnader så effektivt som möjligt.
          </li>
          <li>
            Göra byggprocesser mer utsläppssnåla, med cirkulära flöden och rätt
            material på rätt plats.
          </li>
          <li>
            Sluta att riva de byggnader som redan finns. Detta sparar både
            utsläpp och resurser i form av byggmaterial.
          </li>
          <li>
            Göra byggnader energieffektiva och använda fossilfri energi för
            värme och kyla.
          </li>
          <li>
            Se till att de nya hus vi bygger håller hög kvalitet så att de kan
            underhållas, användas länge, och möta framtidens utmaningar och
            behov.
          </li>
        </ul>
        <p class="future-page__content__paragraph">
          Läs mer om byggande och växthusgasutsläpp här nedanför. Vad säger
          experter från byggbransch och klimatforskning om vad branschen bör
          göra för att ställa om? Hur snabbt måste vi minska våra utsläpp och
          hur ser statistikläget ut? Vad är det historiska sambandet mellan
          byggande och energi?
        </p>
        <!--  <p class="future-page__content__paragraph">Det är också viktigt att byggnader är energieffektiva så att lite energi krävs för värme/kyla, och att fossilfria energikällor används.</p>
        <p class="future-page__content__paragraph">De nya hus vi bygger, när vi väl bygger, måste hålla hög kvalitet så att de kan användas länge, kunna underhållas, och vara anpassade för framtidens utmaningar och behov.</p>
        <p class="future-page__content__paragraph">I artiklarna här nedan kan du läsa mer om vad experter från byggbranschen och klimatforskare anser att branschen bör göra för att ställa om.</p> -->
      </div>
      <ArticleListMolecule v-if="articles" :articles="articles" />
    </div>
    <div class="future-page__content" v-if="isEnglish">
      <div class="future-page__textContent">
        <p class="future-page__content__paragraph">
          Reducing greenhouse gas emissions from construction is a complex
          challenge with several conflicting goals. The following principles
          highlight how we can address this challenge.
        </p>
        <ul class="future-page__content__ul">
          <li>Build less, only what we need.</li>
          <li>
            Use both new and existing buildings as efficiently as possible.
          </li>
          <li>
            Decarbonise construction, with circular flows and the right material
            in the right place.
          </li>
          <li>
            Stop demolishing existing buildings. This saves both emissions and
            resources from building materials.
          </li>
          <li>
            Make buildings energy efficient and use fossil-free energy for
            heating and cooling.
          </li>
          <li>
            Make sure that new houses we build are of high quality so that they
            can be maintained, used for a long time, and meet the challenges and
            needs of the future.
          </li>
        </ul>
        <p class="future-page__content__paragraph">
          Read more about construction and greenhouse gas emissions below. What
          do experts from the construction industry and climate research say
          about what the industry should do to change? How quickly must we
          reduce our emissions and what do the statistics look like? What is the
          historical connection between construction and energy?
        </p>
        <!--  <p class="future-page__content__paragraph">Det är också viktigt att byggnader är energieffektiva så att lite energi krävs för värme/kyla, och att fossilfria energikällor används.</p>
        <p class="future-page__content__paragraph">De nya hus vi bygger, när vi väl bygger, måste hålla hög kvalitet så att de kan användas länge, kunna underhållas, och vara anpassade för framtidens utmaningar och behov.</p>
        <p class="future-page__content__paragraph">I artiklarna här nedan kan du läsa mer om vad experter från byggbranschen och klimatforskare anser att branschen bör göra för att ställa om.</p> -->
      </div>
      <ArticleListMolecule v-if="articles" :articles="articles" />
    </div>
  </div>
</template>

<script>
import { inject, computed } from "vue";
import ArticleListMolecule from "../molecules/ArticleListMolecule.vue";
import BannerAtom from "../atoms/BannerAtom.vue";
import api from "@/api/contentful.js";

export default {
  components: {
    ArticleListMolecule,
    BannerAtom,
  },
  data() {
    return {
      image: require("@/assets/images/future.jpg"),
      articles: false,
      currentPath: "/future",
    };
  },
  setup() {
    const language = inject("language"); // Get the current language from context
    const isEnglish = computed(() => language.value === "en"); // Check if it's English

    const bannerTitle = computed(() =>
      isEnglish.value ? "Reducing Emissions" : "Hur minskar vi utsläppen?",
    );

    return {
      isEnglish,
      bannerTitle,
    };
  },
  methods: {
    async fetchArticles(limit, skip) {
      return await api.getArticles(limit, skip);
    },
  },
  async mounted() {
    this.articles = await this.fetchArticles(30, 0);
  },
};
</script>

<style scoped>
.future-page {
  margin: auto;
}
p {
  font-size: 18px;
}
.future-page__content {
  padding: 20px;
  margin-top: -20;
  margin-bottom: 30px;
  margin: auto;
  max-width: 800px;
}
.future-page__textContent {
  padding-bottom: 30px;
}
.future-page__content__paragraph {
  font-family: "bred", sans-serif;
  margin: 25px 0;
  line-height: 1.2;
  letter-spacing: 0.5px;
  color: white;
  max-width: 800px;
  margin: 16px auto;
}
.future-page__content__ul {
  padding-left: 50px;
}
.future-page__content__ul li {
  color: white;
  line-height: 1.2;
  letter-spacing: 0.5px;
  margin: 16px auto;
  max-width: 800px;
  font-size: 18px;
}

@media (min-width: 1024px) {
  .future-page__content {
    display: block;
    max-width: 100%;
    padding: 40px;
    padding-left: 42px;
    float: left;
  }

  .future-page__content__paragraph {
    padding-left: 0;
    margin: 0;
  }
}
</style>
